import { ScrollView, StyleSheet, Text } from 'react-native'

import { Stack, XStack } from '@zet/design-system/layout'

import UserFlowRecommendationCard from './UserFlowRecommendationCard'
import { UserFlowProduct } from './types'

const RecommendationSection = ({
  title,
  subtitle,
  products,
  customerId,
  onApplySuccess,
  horizontal = false,
}: {
  title: string
  subtitle: string
  products: UserFlowProduct[]
  customerId: number
  onApplySuccess?: () => void
  horizontal?: boolean
}) => {
  if (!products?.length) {
    return null
  }

  return (
    <Stack style={styles.container}>
      {title ? <Text style={styles.title}>{title}</Text> : null}
      {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      <ScrollView
        horizontal={horizontal}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={[
          styles.scrollContent,
          horizontal && styles.scrollContentHorizontal,
          (title || subtitle) && styles.scrollContentWithHeader,
        ]}
      >
        <XStack
          style={[
            styles.row,
            horizontal ? styles.rowHorizontal : styles.rowVertical,
          ]}
        >
          {products?.map((product, index) => (
            <UserFlowRecommendationCard
              key={`${product?.partnerId || ''}-${product?.id || ''}-${index}`}
              product={product}
              customerId={customerId}
              onApplySuccess={onApplySuccess}
              compact={horizontal}
              index={index}
            />
          ))}
        </XStack>
      </ScrollView>
    </Stack>
  )
}

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
  },
  row: {
    marginLeft: 16,
  },
  rowHorizontal: {
    flexDirection: 'row',
    gap: 20,
  },
  rowVertical: {
    flexDirection: 'column',
    gap: 16,
  },
  scrollContent: {
    paddingTop: 20,
    paddingBottom: 4,
  },
  scrollContentHorizontal: {
    paddingRight: 16,
  },
  scrollContentWithHeader: {
    paddingTop: 16,
  },
  subtitle: {
    marginTop: 4,
    fontFamily: 'THICCCBOI-Medium',
    fontSize: 12,
    lineHeight: 18,
    letterSpacing: -0.24,
    color: '#4B5563',
  },
  title: {
    fontFamily: 'THICCCBOI-ExtraBold',
    fontSize: 15,
    lineHeight: 20,
    letterSpacing: -0.3,
    color: '#374151',
  },
})

export default RecommendationSection
